import TrendSignalSettingsActions from "./TrendSignalSettingsActions";
import TrendSignalSettingsGetters from "./TrendSignalSettingsGetters";
import TrendSignalSettingsMutations from "./TrendSignalSettingsMutations";
import TrendSignalsService from "@/services/common/TrendSignalsService";

const state = TrendSignalsService.EmptyTrendSignalSettingsStateFactory();

const { actions } = TrendSignalSettingsActions;

const { getters } = TrendSignalSettingsGetters;

const { mutations } = TrendSignalSettingsMutations;

const namespaced = true;

export default {
	namespaced,
	state,
	actions,
	getters,
	mutations,
};